import React, { Component } from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";
import DocumentListing from './DocumentListing';
import GridListing from './GridListing';
import {callDELETE, callGET, callPOST} from '../../../../Utils/ApiUtil';
import {roundOffTwoDecimal} from '../../../../Utils/CommonFunctions';

class MainContent extends Component {
	constructor(props) {
        super(props);
    }

    state={
    	tableRecords:{
        tableHead:[
          {
          	name:"",
          	type:"Actions",
          	isShow:true,
          	attributes:{style:{width: "75px"}}
          },          
          {
            name:"Name",
            type:"Setting",
            href:"",
            clickHandler:"",
            isShow:true,
            attributes:{
            }
          },
          {
            name:"Owner",
            type:"Text",
            href:"",
            isShow:true,
            clickHandler:"",
            attributes:{
            }
          },
          {
            name:"Type",
            type:"Text",
            href:"",
            isShow:true,
            clickHandler:"",
            attributes:{
            }
          },
          {
            name:"Size",
            type:"Text",
            href:"",
            isShow:true,
            clickHandler:"",
            attributes:{
            }
          },          
        ],
        tableData:[], 
        pagination:{
          page:0,
          orderBy:'',
          perPage:10,
          direction:'ASC',
          totalRecords:0,
          search:''
        }
      },
    }

    componentDidMount = () => {
    	//console.log('componentDidMount',this.props.ListingModules) 
    	this.callListingData();
    }

    componentDidUpdate = (prevProps) => {
    	if(prevProps.ListingModules!==this.props.ListingModules || prevProps.ListingDirectoryID!==this.props.ListingDirectoryID || prevProps.ListingType!==this.props.ListingType || prevProps.ListingModulesFlag!==this.props.ListingModulesFlag){
    		console.log('componentWillUpdate', this.props.ListingType,prevProps.ListingType)
    		this.callListingData();
    	}    	
    }

    callListingData = () => {

      let ListingModules = this.props.ListingModules;
      let ListingDirectoryID = this.props.ListingDirectoryID;
      let paramListing = '';
      if(ListingModules==='Images'){
        paramListing='?image_only=true';
      }

      if(ListingModules==='Documents'){
        paramListing='?document_only=true';
      }

      if(ListingModules==='All'){
        paramListing='?image_only=true&document_only=true';
      }

      if(ListingModules==='Directory'){
        paramListing='?directory_id='+ListingDirectoryID;
      }

      if(ListingModules==='Favourite'){
        paramListing='?favourite_only=true';
      }

      this.props.Loader(true)
      callGET("document/search"+paramListing)
      .then(res => {      
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){             
            //console.log(response.data, 'response.data') 
            let updateTableData = (response.data!==undefined && response.data.length!==0)?response.data[0].documents.map((item,index)=>{
            	let isFav = '';
             	if(item.favourite === true){ isFav = 'text-warning';} 

             	let isFileOrFolder = 'fas fa-folder text-success'
             	if(item.type){
             		isFileOrFolder = 'fas fa-file text-success';	
             	}

             	let settings = '';
             	let moveAction = '';
             	let copyAction = '';
             	let favAction = '';
             	if(item.type){
             		settings = "";
             		moveAction = {
             			//href:"",
                      	clickHandler:this.props.toggleDirectoryChoosePopup.bind(this,'Move',item.id),
                      	attributes:{
                      		className:"dropdown-item"
                      	},
                      	access_mode:true,
                      	name:"Move"	
             		}

             		copyAction = {
             			//href:"",
                      	clickHandler:this.props.toggleDirectoryChoosePopup.bind(this,'Copy',item.id),
                      	attributes:{
                      		className:"dropdown-item"
                      	},
                      	access_mode:true,
                      	name:"Copy"	
             		} 

             		favAction = {
                      	//type:'edit',
                      	attributes:{
                        className:"p-1"
                      	},
                      	iconClass:'fas fa-star '+isFav,
                      	access_mode:true,
                      	href:"#",
                      	name:"",
                      	clickHandler: this.props.assignFavouriteHandler.bind(this,item.id,!item.favourite)
                    }              	
              	}else {
                	settings = {
                        //href:"",
                      	clickHandler:this.props.toggleSubFolderPopup.bind(this,item.id),
                      	attributes:{
                      		className:"dropdown-item"
                      	},
                      	access_mode:true,
                      	name:"Create Sub Folder"
                  	}
                  	
                  	favAction = {
                      	//type:'edit',
                      	attributes:{
                        className:"p-1"
                      	},
                      	iconClass:'fas fa-star invisible',
                      	access_mode:true,
                      	href:"#",
                      	name:"",
                      	//clickHandler: this.props.assignFavouriteHandler.bind(this,item.id,item.favourite)
                    }
              	}
			const settingActionMore = [
				{
				  //href:"",
				  clickHandler:(item.type)?this.props.deleteFileHandler.bind(this,item.id):this.props.deleteDirectoryHandler.bind(this,item.id),
				  attributes:{
				  className:"dropdown-item"
				  },
				  access_mode:true,
				  name:"Delete"
				},
				{
				  //href:"/settings/"+item.display_name+"/"+item.id,
				  clickHandler:(item.type)?this.props.downloadFileHandler.bind(this,item.id, item.name):this.props.downloadDirectoryHandler.bind(this,item.id),
				  attributes:{
				  className:"dropdown-item"
				  },
				  access_mode:true,
				  name:"Download"
				},
				settings,
				moveAction,
				copyAction
			  ];
              return {
                className:'icon_hover cursor-pointer',
                rowId:"",
                gData:{...item,actionMore:settingActionMore},
                data:{
                	actions:[
	                    favAction,
	                    {
		                    //type:'delete',
		                    attributes:{
		                      className:"p-1"
		                    },
		                    iconClass:isFileOrFolder,
		                    access_mode:true,
		                    //clickHandler:this.deleteWindow.bind(this,item.organization_window_id),
		                    name:""
	                  	}
	                ],
                  	file_name:{
	                    value: item.name,
	                    clickHandler: (item.type)?'':this.props.assignListingModules.bind(this,'Directory',item.id),
	                    param:{
	                        data:{...item},
	                    },
	                    attributes:{
	                        id: item.id                        
	                    },
	                    setting:{
	                      attributes:{},
	                      actionMore:settingActionMore
	                    },                    
                  	},
                  	owner:item.document_owner,
                  	type:item.type,
                  	size:item.size ? roundOffTwoDecimal(item.size/1000) + ' KB' : '',
                }
              }
            }):[]; 

            const totalRecords = (response.data!==undefined && response.data.length!==0)?response.data[0].documents.length:0;
            this.setState({status:200, tableRecords:{
              tableData:{data:updateTableData,status:200},
              tableHead:this.state.tableRecords.tableHead ,
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});
          }else{
           
            const totalRecords = 0;//response.data.totalElements;
            this.setState({status:200, tableRecords:{
              tableData:[],
              tableHead:this.state.tableRecords.tableHead ,
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});

          }
        }
        this.props.Loader(false)
      }, (error) => {      
        // this.props.failMessage('Something wrong on Listing1111..');
        console.log(error);
        this.props.Loader(false)
      }); 
    }

    render () {
    	// console.log('ListingType',this.props.ListingType);
    	return(
	        <Wrp>
	        	<div className="view view-xl" id="wrapper">
					<div className="outerPort" style={{overflow:"auto", left:"0px", top:"5px"}}>
						<div className={(this.props.ListingType === 'Table') ? "" : "card-body"}>
							{
								(this.props.ListingType === 'Table') ?
								<DocumentListing
									tableRecords={this.state.tableRecords}
								/>
								:
								<GridListing assignListingModules={this.props.assignListingModules} tableRecords={this.state.tableRecords} />
							}
						</div>     
					</div>    			
	          </div>
	        </Wrp>
	    )	
    }
}

export default MainContent;

